"use client";

import { Box } from "@mui/material";
import {
  FacebookRounded,
  LinkedIn,
  Telegram,
  Twitter,
} from "@mui/icons-material";
import SocialIcon from "@/src/components/common/_partials/footer/social-icon/social-icon";

export const SOCIAL_NETWORKS = {
  facebook: FacebookRounded,
  x: Twitter,
  linkedin: LinkedIn,
  telegram: Telegram,
} as const;

export type SocialNetwork = keyof typeof SOCIAL_NETWORKS;

export type FooterSocialItem = {
  network: SocialNetwork;
  title: string;
  link: string;
};

export default function SocialBox({
  socialItems,
}: {
  socialItems: FooterSocialItem[];
}) {
  if (socialItems.length === 0) return null;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 0.5,
      }}
    >
      {socialItems.map((item) => (
        <SocialIcon
          key={item.network}
          link={item.link}
          title={item.title}
          icon={SOCIAL_NETWORKS[item.network]}
        />
      ))}
    </Box>
  );
}
